import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { map } from '@beef/utils';
import { BuilderExtension } from "../BuilderExtension";
import { NodeTree } from "./NodeTree";
import { ChildUtils } from "../ChildUtils";
import { NodeTreeProjection } from "./NodeTreeProjection";
export var NodeTreeExtension = /*#__PURE__*/function (_BuilderExtension) {
  _inherits(NodeTreeExtension, _BuilderExtension);
  var _super = _createSuper(NodeTreeExtension);
  function NodeTreeExtension() {
    _classCallCheck(this, NodeTreeExtension);
    return _super.apply(this, arguments);
  }
  _createClass(NodeTreeExtension, [{
    key: "create",
    value: function create() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new NodeTree(map(data, function (nodeData, nodeId) {
        return _this.next.create(nodeData, _objectSpread(_objectSpread({}, params), {}, {
          nodeId: nodeId
        }));
      }), new ChildUtils(this.next));
    }
  }, {
    key: "serialize",
    value: function serialize(cls) {
      var _this2 = this;
      return map(cls.nodes, function (item) {
        return _this2.next.serialize(item);
      });
    }
  }, {
    key: "createProjection",
    value: function createProjection() {
      var _this3 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new NodeTreeProjection(map(data, function (nodeData, nodeId) {
        return _this3.next.createProjection(nodeData, _objectSpread(_objectSpread({}, params), {}, {
          nodeId: nodeId
        }));
      }));
    }
  }]);
  return NodeTreeExtension;
}(BuilderExtension);